import type { TopicChapterListResponse } from './apiContracts';
import type { PrototypeApiClient } from './apiClient';

/**
 * Shares the directory read only between consumers of one Topic paint.
 *
 * The caller owns this closure, so a new navigation or identity-driven repaint
 * gets a new request. A successful result remains available only to the two
 * consumers of this paint; a failure is forgotten so their retry reads again.
 * This is not a cross-navigation client cache.
 */
export type TopicChapterRequest = () => Promise<TopicChapterListResponse>;

export function createTopicChapterRequest(api: Pick<PrototypeApiClient, 'listTopicChapters'>, slug: string): TopicChapterRequest {
	let pending: Promise<TopicChapterListResponse> | null = null;
	return () => {
		if (pending) return pending;
		const request = api.listTopicChapters(slug);
		pending = request;
		void request.then(
			() => undefined,
			() => { if (pending === request) pending = null; },
		);
		return request;
	};
}
